

import axois from '../utils/axiosExport'
   
// 首页产品分类
export function productTypeList(data?: any) {
  return axois.request({
    url: `/admin/sys/config/product-type/list`,
    method: "get",
    data: {
      ...data,
    },
  });
}   
// 首页产品分类（带图片）
export function productTypeListValue(data?: any) {
  return axois.request({
    url: `/admin/sys/config/product-type/value`,
    method: "get",
    data: {
      ...data,
    },
  });
}
// 首页-查询精选商品
export function productRecommended(data?: any) {
  return axois.request({
    url: `/admin/product/recommended`,
    method: "get",
    data: {
      ...data,
    },
  });
}
// 加入购物车
export function addCart(data?: any) {
  return axois.request({
    url: `/admin/shopping-cart/add`,
    method: "post",
    data: {
      ...data,
    },
  });
}
// 分页查询产品
export function productPage(data?: any) {
  return axois.request({
    url: `/admin/product/page`,
    method: "POST",
    data: {
      ...data,
    },
  });
}
// 产品详情
export function productDetail(id?: any) {
  return axois.request({
    url: `/admin/product/detail/${id}`,
    method: "get",
    // data: {
    //   ...data,
    // },
  });
}
// 获取用户信息
export function getUserInfo(data?: any) {
  return axois.request({
    url: `/admin/auth/info`,
    method: "get",
    data: {
      ...data,
    },
  });
}
// 分页查询Banner
export function bannerPage(data?: any) {
  return axois.request({
    url: `/admin/banner/page`,
    method: "POST",
    data: {
      ...data,
    },
  });
}
// 查询展示的Banner列表
export function bannerList(data?: any) {
  return axois.request({
    url: `/api/back/banner/list`,
    method: "GET",
    data: {
      ...data,
    },
  });
}
// 修改用户信息
export function updateInfo(data?: any) {
  return axois.request({
    url: `/admin/auth/update-info`,
    method: "post",
    data: {
      ...data,
    },
  });
}
// 分页查询订单
export function orderPage(data?: any) {
  return axois.request({
    url: `/admin/order/page`,
    method: "POST",
    data: {
      ...data,
    },
  });
}
// 分页查询产品概念展示
export function productConceptPage(data?: any) {
  return axois.request({
    url: `/admin/product/concept-display/page`,
    method: "POST",
    data: {
      ...data,
    },
  });
}
// 产品概念展示详情
export function productConceptDetail(id?: any) {
  return axois.request({
    url: `/admin/product/concept-display/detail/${id}`,
    method: "get",
    // data: {
    //   ...data,
    // },
  });
}
// 分页查询活動花絮
export function activityPage(data?: any) {
  return axois.request({
    url: `/admin/market-activities/page`,
    method: "POST",
    data: {
      ...data,
    },
  });
}
// 查询活動花絮详情
export function activityDetail(id?: any) {
  return axois.request({
    url: `/admin/market-activities/detail/${id}`,
    method: "get",
    // data: {
    //   ...data,
    // },
  });
}
// 獲取會員等級
export function getMemberLevel(data?: any) {
  return axois.request({
    url: `/admin/sys/config/member-type`,
    method: "get",
    data: {
      ...data,
    },
  });
}
// 上传文件
export function fileUpload(data?: any) { 
  const formData: any = new FormData(); 
  for (const key in data) {
    if (data[key] instanceof File) {
      formData.append(key, data[key]);  
    } else if (Array.isArray(data[key])) {
      if (data[key].every((item: any) => item instanceof File)) { 
        data[key].forEach((file: any, index: number) => {
          formData.append(`${key}[${index}]`, file);
        });
      } else { 
        formData.append(key, JSON.stringify(data[key]));
      }
    } else if (typeof data[key] === "object") {  
      formData.append(key, JSON.stringify(data[key]));
    } else {
      formData.append(key, data[key]);  
    }
  }

  return axois.request({
    url: "/admin/open/file/upload",
    method: "post",
    headers: {
      'content-type': "multipart/form-data",
    },
    data: formData,
  }); 
}
// 获取文件签名URL
export function fileSignedUrl(data?: any) {
  return axois.request({
    url: `/admin/open/file/getSignedUrl`,
    method: "POST",
    data: {
      ...data,
    },
  });
}
// 提交用户认证信息
export function userAuthSubmit(data?: any) {
  return axois.request({
    url: `/admin/user-auth/submit`,
    method: "POST",
    data: {
      ...data,
    },
  });
}
// 获取当前用户最新认证信息
export function userAuthDetail(data?: any) {
  return axois.request({
    url: `/admin/user-auth/latest`,
    method: "get",
    data: {
      ...data,
    },
  });
}
// 查看当前用户店铺
export function shopDetail(data?: any) {
  return axois.request({
    url: `/admin/shop/detail`,
    method: "post",
    data: {
      ...data,
    },
  });
}
// 设置当前用户店铺Banner
export function shopBanner(data?: any) {
  return axois.request({
    url: `/admin/shop/banner`,
    method: "post",
    data: {
      ...data,
    },
  });
}

// 新增进货记录
export function purchaseAdd(data?: any) {
  return axois.request({
    url: `/admin/product/purchase/add`,
    method: "post",
    data: {
      ...data,
    },
  });
}
// 分页查询进货记录
export function purchasePage(data?: any) {
  return axois.request({
    url: `/admin/product/purchase/page`,
    method: "post",
    data: {
      ...data,
    },
  });
}
// 分页查询商品库存
export function stockPage(data?: any) {
  return axois.request({
    url: `/admin/product/record/page`,
    method: "post",
    data: {
      ...data,
    },
  });
}
// 根据当前登录用户和商品ID更新启用状态
export function updateStatus(data?: any) {
  return axois.request({
    url: `/admin/product/record/enable`,
    method: "post",
    data: {
      ...data,
    },
  });
}
// 添加订阅
export function addSubscription(data?: any) {
  return axois.request({
    url: `/admin/subscription/add`,
    method: "post",
    data: {
      ...data,
    },
  });
}
// 查詢用戶盈利商品庫存
export function profitStockPage(data?: any) {
  return axois.request({
    url: `/admin/product/record/profit/page`,
    method: "post",
    data: {
      ...data,
    },
  });
}